import React from 'react'
import "./InfoBox.css"
import {Card, CardContent, Typography } from "@material-ui/core"

const InfoBox = ({title, cases, isRed,  active, total, ...props}) => {
    return (
        <Card onClick={props.onClick} className={`infoBox ${active && 'infoBox--selected'} ${isRed && 'infoBox--red'}` }>
            <CardContent>
                {/*title*/}
                <Typography className="infoBox_title" color="textSecondary">{title}</Typography>
                {/*number of cases*/}
                <h2 className={`infoBox_cases ${!isRed && 'infoBox_cases--green'}`}>{cases}</h2>
                {/*total */}
                <Typography color="textSecondary">{total} Total</Typography>
            </CardContent>
        </Card> 
    )
}

export default InfoBox
